import Vue from 'vue';
import { getPageInfo, fetchCounponDetail, checkStudentAuth } from './api';
import {
  resolveComponents,
  resolveCouponRule,
  isXL
} from '@/components/templates/helper';
import actComponentLib from './components/actComponentsLib';
import { keys } from 'lodash-es';
import { oc } from 'ts-optchain';
import { AUTH_STATUS, BIND_STATUS, PAGE_STATUS } from './constants';
import { isXlApp, isXlMiniProgram } from '@/utils/judgeEnv';

import { toXlWxaWebCommon, composeShareLink } from '@/utils';

import fetchCoupeInfo from './coupe';

import { goBackWhileReturn } from './help';

const studentAuthPath = '/pages/permission/student';

export default {
  namespaced: true,
  state() {
    return {
      actData: null,
      tplData: null,
      actCode: null,
      pageStatus: null,
      pinnedBtnComponentObjs: [],
      flowComponentObjs: [],
      positionComponentObjs: [],
      coupeInfo: {}
    };
  },
  actions: {
    parseCompnents({ commit }, { metaInfo, actData }) {
      const components = metaInfo.components;
      if (!components || !components.length) {
        return;
      }
      // 拿到 metaInfo 之后直接调 helper.resolveComponents 即可生成组件数组用于渲染
      const [
        pinnedBtnComponentObjs, // pinnedBtnComponentObjs 就是右上角固定按钮组，比较特殊，需要单独提取
        flowComponentObjs, // 流式布局的组件数组
        positionComponentObjs // 固定定位的组件数组
      ] = resolveComponents(components, { actData, actComponentLib });
      commit('setComponentObjs', {
        pinnedBtnComponentObjs,
        flowComponentObjs,
        positionComponentObjs
      });
    },
    async getCoupeInfo({ commit }) {
      console.log('fetchCoupeInfo::::----');
      const result = await fetchCoupeInfo();
      commit('setCoupeInfo', result);
    },
    async getActData({ commit, dispatch }, actCode) {
      Vue.prototype.$hll.showLoading({ disableLogo: isXL() });
      let actData;
      try {
        actData = await getPageInfo(actCode);
      } catch (error) {
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }
      let metaInfo = {};
      try {
        metaInfo = JSON.parse(actData.metaInfo);
      } catch (e) {
        throw new Error('模板数据 parse 出错');
      }
      if (!actData.taskInfos) {
        actData.taskInfos = [];
      }
      commit('setActData', actData);
      commit('setTplData', metaInfo);
      // 解析组件
      dispatch('parseCompnents', { metaInfo, actData });
    },

    async getStatusAuthStatus({ state, commit }) {
      Vue.prototype.$hll.showLoading({ disableLogo: isXL() });
      let authData = {};
      try {
        authData = await checkStudentAuth();
      } catch (error) {
        throw error;
      } finally {
        Vue.prototype.$hll.hideLoading();
      }

      const authDataKeys = keys(authData);
      let pageStatus = PAGE_STATUS.notBind;
      if (authDataKeys.length > 0) {
        const { bindStatus, isStudent } = oc(authData)({});

        if (bindStatus === BIND_STATUS.notBind) {
          pageStatus = PAGE_STATUS.notBind;
        } else if (bindStatus === BIND_STATUS.auditIng) {
          pageStatus = PAGE_STATUS.auditIng;
        } else if (bindStatus === BIND_STATUS.hasBind) {
          if (isStudent === AUTH_STATUS.isStudent) {
            pageStatus = PAGE_STATUS.activity;
          } else {
            pageStatus = PAGE_STATUS.auditFailed;
          }
        }
      } else {
        pageStatus = PAGE_STATUS.notBind;
      }

      if (pageStatus !== PAGE_STATUS.activity) {
        // 活动在小拉app中打开， 若是未认证通过，需要跳转至小程序，进入活动
        // isStudentAuth=1&u=1&ball_from=1&token=c854bd76eb3143ebb0c7592d25e38bc6&app_ref=YY-CS-A-G-xiaola-bd-ios&tpl=5#/
        const actLink = composeShareLink(['code', 'u', 'tpl', 'bl', 'ref'], {
          isStudentAuth: 1
        });
        if (isXlApp()) {
          goBackWhileReturn();
          toXlWxaWebCommon(actLink);
        } else if (isXlMiniProgram()) {
          console.log('common-logic 跳转小程序认证');
          const referrer = document.referrer;

          const __referrerParamStr = referrer
            ? `&fail=${encodeURIComponent(referrer)}`
            : '';

          console.log(__referrerParamStr);

          const coupeInfo = state.coupeInfo;
          const { studentAuthBanner, studentAuthDescText } = oc(coupeInfo)({});
          const authPath = `${studentAuthPath}?background=${studentAuthBanner}&desc=${studentAuthDescText}&success=${encodeURIComponent(
            actLink
          )}`;
          wx.miniProgram.redirectTo({
            url: authPath
          });
        } else {
          toXlWxaWebCommon(actLink);
        }
      }

      commit('setPageStatus', pageStatus);
    },
    async getCouponDetail({ commit }, couponCode) {
      try {
        const res = await fetchCounponDetail({
          rewardCode: couponCode, // 奖励码
          rewardType: 4 //权益的类型 4-卡券
        });
        if (res) {
          const couponRules = resolveCouponRule(res);
          commit('setCouponRule', { couponRules, couponCode });
        }
      } catch (error) {
        throw error;
      }
    }
  },
  mutations: {
    setTplData(state, val) {
      state.tplData = val;
    },
    setActData(state, val) {
      state.actData = val;
    },
    // 设置coupe信息
    setCoupeInfo(state, value) {
      state.coupeInfo = value;
    },
    setPageStatus(state, val) {
      state.pageStatus = val;
    },
    setComponentObjs(
      state,
      { pinnedBtnComponentObjs, flowComponentObjs, positionComponentObjs }
    ) {
      state.pinnedBtnComponentObjs = pinnedBtnComponentObjs;
      state.flowComponentObjs = flowComponentObjs;
      state.positionComponentObjs = positionComponentObjs;
    },
    initSetActCode(state, actCode) {
      state.actCode = actCode;
    },
    setCouponRule(state, { couponRules, couponCode }) {
      const couponListData = state.actData.couponRewards;
      const newCouponListData = couponListData.map(couponItem => {
        if (couponItem.rewardCode === couponCode) {
          return {
            ...couponItem,
            direction: couponRules
          };
        }
        return couponItem;
      });
      state.actData.couponRewards = newCouponListData;
    }
  }
};
